var parent = require('../../es/instance/index-of');

module.exports = parent;



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/features/instance/index-of.js
// module id = 1013
// module chunks = 0